import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class ImageSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'img-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
